

export function partDisplayName(partName: string, partRevision: string | undefined): string {
    return partRevision ? `${partName}_${partRevision}` : partName;
}
